const workGrid = document.querySelector(".work-landing");

if (workGrid) {
  const videos = workGrid.querySelectorAll(".work-landing__video");

  videos.forEach((video) => {
    const iframe = video.querySelector("iframe");
    // store the original src
    const src = iframe.getAttribute("src");

    video.addEventListener("mouseover", () => {
      // append autoplay to the video on hover
      const newSrc = src.replace("autoplay=0", "autoplay=1")
      iframe.setAttribute("src", newSrc);
    });

    video.addEventListener("mouseleave", () => {
      // reset the src to the original
      iframe.setAttribute("src", src);
    });
  })
}